"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerlessPrerender = void 0;
/* eslint-disable react/sort-comp */
var react_side_effect_1 = __importDefault(require("react-side-effect"));
var react_1 = __importStar(require("react"));
// import PropTypes from 'prop-types';
var util_1 = require("./util");
var PROP_NAMES = {
    INTERVAL: 'interval',
    STALE_LIMIT: 'staleLimit',
    LEVEL: 'level',
    INCLUDES: 'includes',
    EXCLUDES: 'excludes',
    FALLBACK: 'fallback',
    MATCHES: 'matches',
    ALGORITHM: 'algorithm',
};
var handleClientStateChange = function () { };
var mapStateOnServer = function (reduceProps) {
    var defaultProps = {
        interval: 10,
        staleLimit: false,
        level: 0,
        includes: null,
        excludes: null,
        fallback: false,
        matches: null,
        algorithm: null,
    };
    return Object.keys(defaultProps).reduce(function (props, key) {
        var _a;
        var propKey = key;
        var reduceProp = reduceProps[propKey];
        var nextProps = props;
        if (util_1.exist(reduceProp)) {
            nextProps = __assign(__assign({}, props), (_a = {}, _a[propKey] = reduceProp, _a));
        }
        return nextProps;
    }, defaultProps);
};
var reducePropsToState = function (propsList) {
    var reduceProps = {
        interval: util_1.getOuttermostProperty(propsList, PROP_NAMES.INTERVAL),
        staleLimit: util_1.getOuttermostProperty(propsList, PROP_NAMES.STALE_LIMIT),
        level: util_1.getOuttermostProperty(propsList, PROP_NAMES.LEVEL),
        includes: util_1.aggKeysFromPropsList(propsList, PROP_NAMES.INCLUDES),
        excludes: util_1.aggKeysFromPropsList(propsList, PROP_NAMES.EXCLUDES),
        fallback: util_1.getOuttermostProperty(propsList, PROP_NAMES.FALLBACK),
        matches: util_1.aggMatchesFromPropsList(propsList, PROP_NAMES.MATCHES),
        algorithm: util_1.getOuttermostProperty(propsList, PROP_NAMES.ALGORITHM),
    };
    return reduceProps;
};
function factory(Component) {
    var Spr = /** @class */ (function (_super) {
        __extends(Spr, _super);
        function Spr() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(Spr, "canUseDOM", {
            set: function (canUseDOM) {
                Component.canUseDOM = canUseDOM;
            },
            enumerable: false,
            configurable: true
        });
        Spr.prototype.render = function () {
            var newProps = __assign({}, this.props);
            var validate = this.verify();
            if (!validate) {
                throw new Error('invalid props, check usage');
            }
            return react_1.createElement(Component, __assign({}, newProps));
        };
        Spr.prototype.verify = function () {
            return true;
        };
        Spr.rewind = Component.rewind;
        Spr.peek = Component.peek;
        Spr.config = function () {
            var mappedState = Component.rewind();
            return mappedState;
        };
        return Spr;
    }(react_1.default.Component));
    return Spr;
}
var NullComponent = function () { return null; };
var SprSideEffects = react_side_effect_1.default(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
exports.ServerlessPrerender = factory(SprSideEffects);
/* eslint-enable react/sort-comp */
